import "./Contact.scss";
import { motion, useScroll, useSpring, useTransform } from "framer-motion";
import ExternalLink from "../../ExternalLink";
import RenderIf from "../../RenderIf";
import { useWindowSize } from "../../../helpers/functions/hooks";
import Footer from "../../Footer";
import Spacer from "../../Spacer";

const Contact = ({ contactSection }: { contactSection: React.RefObject<HTMLElement> }): JSX.Element => {
    const { scrollYProgress } = useScroll({
        target: contactSection,
        offset: ['start end', 'end end']
    });
    const { width } = useWindowSize();

    const slideAnimation = useTransform(useSpring(scrollYProgress, { stiffness: 250, damping: 30 }), value => -(value * 100) + "dvh");

    return (
        <section id="contact" ref={contactSection}>
            <motion.div id="contact-slidein" className={width < 950 ? 'mobile-slidein' : ''} style={{ y: width >= 950 ? slideAnimation : undefined }}>
                <div id="contact-content">
                    <motion.h1 initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ type: 'tween', duration: 0.6 }}>Let's get in touch</motion.h1>
                    <div id="contact-links">
                        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ type: 'tween', duration: 0.6 }}>
                            <ExternalLink text='send me an email' href='mailto:pranav.pakanati@gmail.com' />
                        </motion.div>
                        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ type: 'tween', duration: 0.6 }}>or,</motion.p>
                        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ type: 'tween', duration: 0.6 }}>
                            <ExternalLink text='give me a call' href='tel:214-604-6407' />
                        </motion.div>
                    </div>
                    <motion.h4 initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ type: 'tween', duration: 0.6 }}>
                        <span className="hover-link" onClick={() => navigator.clipboard.writeText('pranav.pakanati@gmail.com')}>Copy emai<span className="last-letter">l</span>
                        </span>
                        <RenderIf condition={width <= 500} fallback={<>{' // '}</>}><br ></br></RenderIf>
                        <span className="hover-link" onClick={() => navigator.clipboard.writeText('(214)-604-6407')}>Copy phon<span className="last-letter">e</span></span>
                    </motion.h4>
                    <motion.div id="contact-links-footer" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ type: 'tween', duration: 0.6 }}>
                        <Footer /> 
                        <Spacer />
                    </motion.div>
                </div>
            </motion.div>
        </section>
    );
}

export default Contact;
